var AZURE_TO_CSP_REGION = {
  uksouth: 'UK',
  ukwest: 'UK',
  northeurope: 'UK',
  westeurope: 'UK',
  francecentral: 'UK',
  francesouth: 'UK',
  switzerlandnorth: 'UK',
  switzerlandwest: 'UK',
  germanywestcentral: 'UK',
  germanynorth: 'UK',
  norwayeast: 'UK',
  norwaywest: 'UK',
  swedencentral: 'UK',
  swedensouth: 'UK',
  italynorth: 'UK',
  polandcentral: 'UK',
  spaincentral: 'UK',

  eastus: 'US',
  eastus2: 'US',
  centralus: 'US',
  northcentralus: 'US',
  southcentralus: 'US',
  westcentralus: 'US',
  westus: 'US',
  westus2: 'US',
  westus3: 'US',
  centraluseuap: 'US',
  eastus2euap: 'US',

  canadacentral: 'CA',
  canadaeast: 'CA',

  eastasia: 'AS',
  southeastasia: 'AS',
  japaneast: 'AS',
  japanwest: 'AS',
  koreacentral: 'AS',
  koreasouth: 'AS',
  australiaeast: 'AS',
  australiasoutheast: 'AS',
  australiacentral: 'AS',
  australiacentral2: 'AS',
  centralindia: 'AS',
  southindia: 'AS',
  westindia: 'AS',
  indonesiacentral: 'AS',
  newzealandnorth: 'AS',

  uaenorth: 'ME',
  uaecentral: 'ME',
  israelcentral: 'ME',
  qatarcentral: 'ME',

  brazilsouth: 'LA',
  brazilsoutheast: 'LA',
  mexicocentral: 'LA',

  southafricanorth: 'LA',
  southafricawest: 'LA'
};

export function azureRegionToCspCode(azureRegion) {
  if (!azureRegion) return 'UK';
  var code = AZURE_TO_CSP_REGION[azureRegion.toLowerCase()];
  return code || 'UK';
}

export var CSP_REGIONS = ['UK', 'US', 'CA', 'AS', 'ME', 'LA'];

export function isValidCspRegion(code) {
  return CSP_REGIONS.indexOf(code) !== -1;
}
